module.exports = __webpack_public_path__ + "media/sitemap_page/images/logo01_sp-2b82aa73b76b6babd1cafcc0cb661308.png";